
















import { Component, Watch, Vue } from "vue-property-decorator";

@Component
export default class App extends Vue {
  show = false;
  color = "";
  timeout = 5000;

  @Watch("show")
  autoClosehandler(val: boolean) {
    if (!val) {
      this.show = false;
      this.$store.dispatch("app/deleteMessage");
    }
  }

  get message() {
    const { snackbarMessage } = this.$store.state.app;
    this.color = this.$store.state.app.snackbarColor;
    if (snackbarMessage !== "") {
      this.show = true;
      return snackbarMessage;
    } else {
      return "";
    }
  }

  closeSnackbar() {
    this.show = false;
    this.$store.dispatch("app/deleteMessage");
  }
}
